export default __webpack_public_path__ + "static/media/LowRider.92b3096c.png";